import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Download, CalendarDays } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadMagnet = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [consent, setConsent] = useState(false);
  const [marketing, setMarketing] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Inserisci la tua email");
      return;
    }
    if (!consent) {
      toast.error("Devi accettare l'informativa sulla privacy");
      return;
    }
    setLoading(true);
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/calendario-corsi.pdf`;
    try {
      await axios.post(`${API}/lead`, { email, name, marketing }, { timeout: 8000 });
      toast.success("Perfetto! Scarico il calendario…", { duration: 4000 });
    } catch (err) {
      console.warn("Lead submit non riuscito, avvio comunque il download:", err);
      toast.warning("Non riesco a registrare la email ora, ma il download parte lo stesso.", { duration: 5000 });
    } finally {
      const a = document.createElement("a");
      a.href = url;
      a.download = "treffe-calendario-corsi.pdf";
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setEmail("");
      setName("");
      setConsent(false);
      setMarketing(false);
      setLoading(false);
    }
  };

  return (
    <section data-testid="lead-magnet" className="py-20 md:py-28 bg-brand-black text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-brand-red mb-5">
            <CalendarDays size={16} /> Calendario corsi
          </div>
          <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tighter leading-[0.95] mb-4">
            Scarica il calendario <span className="text-brand-red">corsi 2026</span>
          </h2>
          <p className="text-white/60 max-w-md leading-relaxed">
            Ricevi subito il PDF con tutte le date dei corsi BLS-D, DAE, istruttore
            AHA e sicurezza. Lascia la tua email e lo scarichi all'istante.
          </p>
        </div>

        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="lg:col-span-5 lg:col-start-8 w-full"
        >
          <div className="grid gap-4">
            <input
              data-testid="lead-name"
              className="w-full bg-transparent border-b border-white/20 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-brand-red transition-colors"
              placeholder="Nome (opzionale)"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              data-testid="lead-email"
              type="email"
              className="w-full bg-transparent border-b border-white/20 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-brand-red transition-colors"
              placeholder="La tua email *"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label className="flex items-start gap-3 text-xs text-white/60 cursor-pointer">
              <input type="checkbox" data-testid="lead-consent" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 w-4 h-4 accent-brand-red shrink-0" />
              <span>Accetto l'<Link to="/privacy" className="text-white underline">informativa privacy</Link> per ricevere il calendario richiesto. *</span>
            </label>
            <label className="flex items-start gap-3 text-xs text-white/60 cursor-pointer">
              <input type="checkbox" data-testid="lead-marketing" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="mt-0.5 w-4 h-4 accent-brand-red shrink-0" />
              <span>Iscrivimi anche alla newsletter con novità e nuove date dei corsi (facoltativo).</span>
            </label>
            <button
              type="submit"
              disabled={loading}
              data-testid="lead-submit"
              className="inline-flex items-center justify-center gap-2 bg-brand-red text-white font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-white hover:text-brand-black transition-colors disabled:opacity-60"
            >
              {loading ? "Attendi…" : <>Scarica il PDF <Download size={16} /></>}
            </button>
            <p className="text-xs text-white/40">
              Niente spam. Solo il calendario e info sui corsi.
            </p>
          </div>
        </motion.form>
      </div>
    </section>
  );
};
